import {createSlice} from '@reduxjs/toolkit';

import {initialState} from './UserModel';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const userSlice: any = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUser: (state, action) => {
			state.token = action.payload.tokens;

			const tmpDataUser = action.payload;
			delete tmpDataUser.token;
			state.user = tmpDataUser;

			state.status = 'authenticated';

			/** status user **/
			state.roles = action.payload.roles;

			state.apiConsumer = action.payload.apiConsumer;

			// save token in storage
			localStorage.setItem('Token', action.payload.tokens);

			if (!action.payload.apiConsumer) {
				localStorage.setItem('apiConsumer', action.payload.apiConsumer);
				localStorage.setItem('Refresh-Token', action.payload.refreshToken);
				state.refreshToken = action.payload.refreshToken;
			}
		},
		setUpdateStatusUser: (/* state, action */) => {
			// update data user
		},
		logoutUser: state => {
			state.user = initialState.user;
			state.token = null;
			state.refreshToken = null;
			state.roles = null;
			state.status = 'not-authenticated';
			localStorage.setItem('Token', '');
			localStorage.setItem('Refresh-Token', '');
			localStorage.setItem('apiConsumer', '');
		},
	},
});

export const {setUser, setUpdateStatusUser, logoutUser} = userSlice.actions;

export default userSlice.reducer;
